module.exports = __webpack_public_path__ + "img/finance.27ee839a.png";